<template>
  <div>
  <b-field class="commonrules-grp hotel-role" :label="`Hotel average nightly cost is more than ${currencySymbol}`">
    <b-input type="number" class="cstmb-input" v-model="hotelDailyCost" @input="$emit('hotelDailyCost',hotelDailyCost)"/>
  </b-field>
  </div>
</template>
<script>
  import { eventBus } from '../../../main';

    export default {
      name: "HotelDailyCost",
      props : { 
     },
      components: {},
      data() {
        return {
          hotelDailyCost : null
        }
      },
      computed: {
        currencySymbol() {
          return this.$store.getters['travellersAndTrips/getUserCurrencyInfo'].symbol;
        }
      },
      methods:{},
      created(){
      eventBus.$on('hotelDailyCost',(data)=>{
        this.hotelDailyCost = data;
      })
      },
      mounted() {
    }
    }
  </script>

  <style scoped>
  </style>